import { render, staticRenderFns } from "./CustomPlaneFormCogData.vue?vue&type=template&id=54b24ef6&scoped=true"
import script from "./CustomPlaneFormCogData.vue?vue&type=script&lang=js"
export * from "./CustomPlaneFormCogData.vue?vue&type=script&lang=js"
import style0 from "./CustomPlaneFormCogData.vue?vue&type=style&index=0&id=54b24ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b24ef6",
  null
  
)

export default component.exports